import { Subtitle } from "@components/styles"
import { styled, theme } from "@theme/stitches.config"
import { Link } from "gatsby"

export const LatestNewsWrapper = styled("div", {
    background: "linear-gradient(224.04deg, rgba(255, 0, 0, 0.8) 24.34%, #B9271C 50.31%)",
    pt: 128,
    pb: 75,
    "@mdDown": {
        pt: 60,
        pb: 60
    }
})

export const TitleWrapper = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap"
})

export const Title = styled("p", {
    fontFamily: theme.fonts.heading,
    fontSize: theme.fontSizes.desktopH2,
    color: theme.colors.white,
    lineHeight: 1.2,
    textTransform: "uppercase",
    "@mdDown": {
        fontSize: theme.fontSizes.mobileH2
    }
})

export const CategoriesWrapper = styled("div", {
    mt: 66,
    display: "flex",
    alignItems: "center",
    mx: -12,
    flexWrap: "wrap"
})

export const Category = styled(Link, {
    mx: 12,
    cursor: "pointer",
    fontFamily: theme.fonts.heading,
    fontSize: theme.fontSizes.desktopH6,
    color: theme.colors.N50,
    lineHeight: 1,
    textTransform: "uppercase",
    mb: 8,
    borderBottom: "2px solid transparent",
    pb: 4,
    variants: {
        active: {
            true: {
                borderBottomColor: "white"
            }
        }
    }
})

export const CardsWrapper = styled("div", {
    mt: 35,
    display: "grid",
    gridTemplateColumns: "1fr",
    gridGap: "40px 30px",
    "@lgUp": {
        gridTemplateColumns: "repeat(2, 1fr)",
        gridGap: "60px 30px"
    },
    "@xlUp": {
        gridTemplateColumns: "repeat(3, 1fr)"
    }
})

export const PaginationWrapper = styled("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 40,
    maxWidth: 127,
    mx: "auto"
})

export const PaginationItem = styled(Link, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.black,
    borderRadius: "50%",
    padding: 15,
    cursor: "pointer",
    transition: "all 200ms ease",
    variants: {
        disabled: {
            true: {
                cursor: "default",
                opacity: 0.5
            },
            false: {
                "&:hover": {
                    backgroundColor: "#252525"
                }
            }
        }
    }
})
